import { extendTheme } from '@chakra-ui/react';

import { createBreakpoints } from '@chakra-ui/theme-tools';

// This is the default breakpoint
const breakpoints = createBreakpoints({
  sm: '30em',
  '2sm': '39.5em',
  md: '48em',
  '2md': '55.75em',
  lg: '62em',
  '2lg': '68.75em',
  xl: '80em',
  '2xl': '96em',
});

const theme = extendTheme({
  breakpoints,
  colors: {
    transparent: 'transparent',
    black: '#000',
    white: '#fff',
    orange: {
      background: '#FDF1E5',
      color: '#EA7A28',
    },
    blue: {
      background: '#E5EDFE',
      color: '#2459FA',
    },
    green: {
      background: '#E3F8E9',
      color: '#55BB4A',
    },
    red: {
      background: '#F9E4E9',
      color: '#DD2841',
    },
    gray: {
      title: '#767489',
      background_1: '#f6f6f6',
    },
    hover: {
      black: '#242424',
    },
  },
  fonts: {
    body: 'Roboto, sans-serif',
    heading: 'Milonga, serif',
  },
  sizes: {
    max: 'max-content',
    min: 'min-content',
    full: '100%',
    fullH: '100vh', //
    half: '50%', //
    '3xs': '12.5rem', //
    '2xs': '16rem',
    xs: '20rem',
    sm: '24rem',
    md: '28rem',
    lg: '32rem',
    xl: '36rem',
    '2xl': '42rem',
    '3xl': '48rem',
    '4xl': '56rem',
    '5xl': '64rem',
    '6xl': '72rem',
    '7xl': '80rem',
    '8xl': '90rem',
    small: '3.625rem',
    'nav-title': '3.43rem',
    status: ' 6.3125rem',
    imageMd: '1.5rem',
    imageMdx: '2rem',
    imageLg: '2.75rem',
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
    '6xl': '3.75rem',
    '7xl': '4.5rem',
    '8xl': '6rem',
    '9xl': '8rem',
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
  },
  lineHeights: {
    normal: 'normal',
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: '2',
    3: '.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
  },
  letterSpacings: {
    tighter: '-0.05em',
    tight: '-0.025em',
    normal: '0',
    wide: '0.025em',
    wider: '0.05em',
    widest: '0.1em',
  },
  space: {
    px: '1px',
    0.5: '0.125rem',
    1: '0.25rem',
    1.5: '0.375rem',
    2: '0.5rem',
    2.5: '0.625rem',
    3: '0.8125rem',
    3.5: '0.875rem',
    4: '1rem',
    5: '1.125rem', //
    5.55: '1.25rem',
    5.5: '1.3125rem',
    6: '1.5rem',
    7: '1.625rem',
    7.5: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem', //
    12: '3rem',
    14: '3.5rem',
    15: '3.75rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    28: '7rem',
    32: '8rem',
    32.5: '8.5rem', //
    36: '9rem',
    40: '10rem',
    44: '11rem',
    48: '12rem', //
    52: '13rem',
    56: '14rem',
    60: '15rem',
    64: '16rem',
    72: '18rem',
    80: '20rem',
    96: '24rem',
  },
  radii: {
    none: '0',
    sm: '0.125rem',
    base: '0.25rem',
    md: '0.375rem',
    lg: '0.6875rem',
    xl: '0.75rem',
    '2xl': '1rem',
    '3xl': '1.5rem',
    '4xl': '1.625rem',
    full: '9999px',
  },
});

export default theme;
